import { createSvgIcon } from 'src/components/Icons/utils';

export default createSvgIcon(
  <path d="M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16zm9-12v8h1.5v2H22v2h-2v-2h-5.5v-1.34l5-8.66H22zm-2 3.133L17.19 16H20v-4.867z" />,
  'H4',
  '0 0 24 24'
);
